import { css } from 'styled-components';

const invertedFocusOutline = /*#__PURE__*/css(["outline:", ";outline-offset:", ";"], ({
  theme
}) => theme.border.focus.inverted, ({
  theme
}) => theme.border.focusOffset);

export { invertedFocusOutline as i };
//# sourceMappingURL=invertedFocusOutline-BxN_kWq6.js.map
